/*=============================================== BurgerPage ===============================================*/

import { useState } from "react"
import { Burger } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const BurgerPage = () => {
    const [isOpen, setIsOpen] = useState(false)

    const items: ItemType[] = [
        {
            content: (
                <Burger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
            ),
            code: "const [isOpen, setIsOpen] = useState(false)\n\n<Burger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />",
            codeTs: "const [isOpen, setIsOpen] = useState<boolean>(false)\n\n<Burger isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "isOpen",
            type: "boolean",
            required: true,
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "width",
            type: "number",
            default: 32,
        },
        {
            subtitle: "height",
            type: "number",
            default: 24,
        },
        {
            subtitle: "borderHeight",
            type: "number",
        },
        {
            subtitle: "noHover",
            type: "boolean",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default BurgerPage
